module.exports = __webpack_public_path__ + "static/img/1.ac5eb84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/hrm/1.png
// module id = pQ2b
// module chunks = 0